import { buildPath } from "@tecorien/mimic";
import { DriverProfileDto } from "generated/graphql";
import { defaultSerializer, SerializerOptions } from "../index";

export const DriverProfileDtoSerializer = {
  type: "DriverProfileDto",
  serializer: (entity: DriverProfileDto, options: SerializerOptions): Partial<DriverProfileDto> | null => {
    const serialized = defaultSerializer(entity, options) as any;
    if (serialized) {
      delete serialized[buildPath<DriverProfileDto>()("status").toString()];
      delete serialized[buildPath<DriverProfileDto>()("fleet").toString()];
      delete serialized[buildPath<DriverProfileDto>()("driver").toString()];
      delete serialized[buildPath<DriverProfileDto>()("entityAttachmentPreviews").toString()];
      delete serialized[buildPath<DriverProfileDto>()("attachmentStatus").toString()];
      delete serialized[buildPath<DriverProfileDto>()("firstPaceRideDate").toString()];
      delete serialized[buildPath<DriverProfileDto>()("latestPaceRideDate").toString()];
    }
    return serialized;
  },
};
